/**
 * Extracts a service remote UUID from Medfile `defaultServices` entries.
 * Accepts bare UUID strings or objects with serviceStationaryUuid / serviceRemoteUuid.
 */
export function extractDefaultServiceUuid(entry) {
  if (typeof entry === 'string') return entry || null;
  if (entry && typeof entry === 'object') {
    return entry.serviceStationaryUuid || entry.serviceRemoteUuid || null;
  }
  return null;
}

/**
 * Formatuje metadane usługi (czas trwania + cena) do postaci „20 min, 200 zł”.
 * Wspólne dla panelu rezerwacji i podsumowania wizyty.
 */
export function formatServiceMeta(service) {
  if (!service) return '';

  const parts = [];

  if (service.duration != null && !Number.isNaN(Number(service.duration))) {
    parts.push(`${Number(service.duration)} min`);
  }

  if (service.price != null && !Number.isNaN(Number(service.price))) {
    const formatted = new Intl.NumberFormat('pl-PL', {
      style: 'currency',
      currency: 'PLN',
      minimumFractionDigits: Number(service.price) % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(Number(service.price));

    parts.push(formatted.replace(/\u00a0/g, ' '));
  }

  return parts.join(', ');
}
